import { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";

import Component from "./Component";
import useInternalNotes from "./useInternalNotes";
import useStore from "../useStore";

const Resources = props => {
  const { t } = useTranslation();
  const [state, setState] = useState({ data: [] })
  const notes = useInternalNotes(!!props.notes)
  const store = useStore((state) => ({
    setResource: state.setResource,
    update: state.update,
    facets: state?.facets?.resources || {},
    location: state.location,
    resource: state.resource,
    resourceLocked: state.resourceLocked,
    service: state.service,
    financier: state.financier,
    clearAt: state.clearAt
  }));

  const onChange = value => {
    if (props.onChange) return props.onChange(value)
    setState(state => ({ ...state, active: value, dirty: true }))
    store.update({ resource: value, resourceLocked: false })
  }

  useEffect(() => {
    if (store.clearAt) setState(s => ({ data: [], force: s.force }))
  }, [store.clearAt])

  useEffect(() => {
    const entries = Object.entries(props.facets ?? store.facets)

    const disabled = []
    const enabled = []
    const data = []

    for (const [id, entry] of entries) {
      const option = { id, ...entry, note: notes[id] }
      if (entry.active) {
        enabled.push(option)
      } else {
        disabled.push(option)
      }
    }

    if (enabled.length) {
      const options = enabled.sort((a, b) => {
        if (a.label?.toLowerCase() < b.label?.toLowerCase()) return -1
        if (a.label?.toLowerCase() > b.label?.toLowerCase()) return 1
        return 0
      })
      data.push({ options, label: `${t('filters_resources_enable_plural', 'Habilitados')}` })
    }

    if (disabled.length) {
      const options = disabled.sort((a, b) => {
        if (a.label?.toLowerCase() < b.label?.toLowerCase()) return -1
        if (a.label?.toLowerCase() > b.label?.toLowerCase()) return 1
        return 0
      })
      data.push({ options, label: `${t('filters_resources_disable_plural', 'Deshabilitados')}` })
    }

    const state = { data }

    if (enabled.length === 1) {
      state.active = { ...enabled[0] }
    }

    state.force = entries.length === 1 && !!state.active

    setState(s => ({ ...state, dirty: s.dirty }))
  }, [props.facets, store.facets, notes])

  useEffect(() => {
    const clearAt = store.clearAt || 0
    const diff = Date.now() - clearAt
    if (props.store !== 'manual' && !store.resourceLocked && (diff > 1000 || state.force) && !state.dirty && state.active?.id && store.resource?.id !== state.active.id) {
      store.setResource({ ...state.active })
    }
  }, [store.clearAt, state.force, state.active, state.dirty, store.resource, store.resourceLocked, props.store])

  return (
    <Component
      show={props.show ?? true}
      isLoading={props.isLoading}
      onChange={onChange}
      highlight={props.highlight}
      data={state.data}
      valueKey="id"
      value={props.value ?? store.resource}
      placeholder={t("resource_plural", { context: "sidebar" })}
    />
  );
};

export default Resources;
